import { Button, Divider, Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import { SelectOption } from '../Annotation/annotation.types';
import {
  createEightDTemplate,
  deleteEightDTemplate,
  EightDTemplate,
  getEightDTemplates,
  setFormResult,
  setSelectedCode,
  updateEightDTemplate
} from './eightDTemplate.slice';
import styles from './EightDTemplate.module.scss';
import SearchItem from '../../Shared/Landing/SearchForm/SearchItem';
import EightDTemplateForm from './EightDTemplateForm';
import { connect } from 'react-redux';
import { deleteOrDeprecate } from '../../../shared/Helpers';

type Props = {
  eightDTemplates: EightDTemplate[];
  loading: boolean;
  formLoading: boolean;
  size: number;
  currentPage: number;
  totalNumber: number;
  codes: SelectOption[];
  selectedCode?: string;
  formResult?: boolean;
  onEightDTemplateInit: (take: number, newPage: number) => void;
  onSetSelectedCode: (code: string | undefined) => void;
  onCreate: (template: EightDTemplate) => void;
  onUpdate: (template: EightDTemplate) => void;
  onDelete: (id: string) => void;
  onSetFormResult: (result: boolean | undefined) => void;
};

const EightDTemplateTable = ({
  eightDTemplates,
  loading,
  formLoading,
  size,
  currentPage,
  totalNumber,
  codes,
  selectedCode,
  formResult,
  onEightDTemplateInit,
  onSetSelectedCode,
  onCreate,
  onUpdate,
  onDelete,
  onSetFormResult
}: Props) => {
  const [showForm, setShowForm] = useState(false);
  const [selectedEightDTemplate, setSelectedEightDTemplate] = useState<EightDTemplate>();

  useEffect(() => {
    onEightDTemplateInit(size, 1);
  }, [onEightDTemplateInit, size]);

  useEffect(() => {
    if (formResult !== false) {
      onHideModal();
      onSetFormResult(undefined);
    }
  }, [formResult, onSetFormResult]);

  const onAdd = () => {
    setShowForm(true);
  };

  const onEdit = (record: EightDTemplate) => {
    setSelectedEightDTemplate(record);
    setShowForm(true);
  };

  const onHideModal = () => {
    setSelectedEightDTemplate(undefined);
    setShowForm(false);
  };

  const onRowDelete = (id: any, method: string) => {
    Modal.confirm({
      title: 'Confirm',
      content: `Are you sure you want to ${method} 8D template?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        onDelete(id);
      }
    });
  };

  const onSubmit = (model: EightDTemplate) => {
    if (selectedEightDTemplate) {
      onUpdate(model);
    } else {
      onCreate(model);
    }
  };

  const columns = [
    {
      title: 'Code',
      key: 'code',
      dataIndex: 'code'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <span>
          {!record.deprecated && (
            <>
              <Button type='link' disabled={record.deprecated} onClick={() => onEdit(record)}>
                Update
              </Button>
              <Divider type='vertical' />
              <Button type='link' onClick={() => onRowDelete(record.id, deleteOrDeprecate(record.canDelete))}>
                {deleteOrDeprecate(record.canDelete)}
              </Button>
            </>
          )}
          {record.deprecated && (
            <Button type='link' onClick={() => {}} disabled={true}>
              Deprecated
            </Button>
          )}
        </span>
      )
    }
  ];
  return (
    <div className={styles.container}>
      <h1 className='mainheader'>8D Templates</h1>
      {showForm ? (
        <EightDTemplateForm
          selectedEightDTemplate={selectedEightDTemplate}
          loading={formLoading}
          onHideModal={onHideModal}
          onSubmit={onSubmit}
        />
      ) : (
        ''
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '1rem' }}>
            <SearchItem
              label='Code'
              value={selectedCode}
              values={codes}
              onChange={value => {
                onSetSelectedCode(value);
                onEightDTemplateInit(size, 1);
              }}
            />
          </span>
        </div>
        <Button className={styles.addEightD} onClick={() => onAdd()}>
          Add 8D Template
        </Button>
      </div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={eightDTemplates}
        rowKey='id'
        scroll={{ y: 500 }}
        pagination={{
          current: currentPage,
          total: totalNumber,
          pageSize: size,
          onChange: (page: number) => {
            onEightDTemplateInit(size, page);
          },
          onShowSizeChange: (current: number, size: number) => {
            onEightDTemplateInit(size, 1);
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  eightDTemplates: state.eightDTemplate.eightDTemplates,
  loading: state.eightDTemplate.loading,
  formLoading: state.eightDTemplate.formLoading,
  size: state.eightDTemplate.size,
  currentPage: state.eightDTemplate.currentPage,
  totalNumber: state.eightDTemplate.totalNumber,
  codes: state.eightDTemplate.codes,
  selectedCode: state.eightDTemplate.selectedCode,
  formResult: state.eightDTemplate.formResult
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onEightDTemplateInit: (take: number, newPage: number) => dispatch(getEightDTemplates(take, newPage)),
  onSetSelectedCode: (code: string | undefined) => dispatch(setSelectedCode(code)),
  onCreate: (template: EightDTemplate) => dispatch(createEightDTemplate(template)),
  onUpdate: (template: EightDTemplate) => dispatch(updateEightDTemplate(template)),
  onDelete: (id: string) => dispatch(deleteEightDTemplate(id)),
  onSetFormResult: (result: boolean | undefined) => dispatch(setFormResult(result))
});

export default connect(mapStateToProps, mapDispatchToProps)(EightDTemplateTable);
